/** Insurance constants shared by the Lux insurance injects. Kind keys mirror `InsuranceCoverageKind` in `src/lib/constants/insurances.ts`. */
const LUX_INSURANCE_KIND_LABELS = {
  council: 'Beiratsversicherung',
  weg_liability: 'Haus- und Grundbesitzerhaftpflicht (WEG)',
  building: 'Wohngebäudeversicherung',
  fire: 'Feuerversicherung',
  storm: 'Sturmversicherung',
  natural_hazard: 'Elementarversicherung',
  water_liability: 'Gewässerschadenhaftpflicht',
  building_liability: 'Haus- und Grundbesitzerhaftpflicht (Gebäude)',
  other: 'Sonstige Versicherung',
}

const LUX_INSURANCE_RISK_LABELS = {
  fire: 'Feuer',
  storm: 'Sturm',
  natural_hazard: 'Elementar',
  water_liability: 'Gewässerschaden',
  building_liability: 'Haus- & Grundbesitzerhaftpflicht',
}

// Property-damage risks that are either part of the Wohngebäude policy or insured on their own; liabilities are always their own contract.
const LUX_INSURANCE_SEPARABLE_RISKS = ['fire', 'storm', 'natural_hazard']

const LUX_INSURANCE_PAGE_SIZE = 10
const LUX_INSURANCE_PENDING_TIMEOUT_MS = 10000
const LUX_INSURANCE_SECTION_HASH = '#insurancePoliciesLux'
// Must match INSURANCE_NOTICE_KEY in src/components/insurances/insurance-form.ts.
const LUX_INSURANCE_NOTICE_KEY = 'luxInsuranceNotice'
const LUX_INSURANCE_FORM_SECTION_ID = 'LuxInsuranceSection'

if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    LUX_INSURANCE_KIND_LABELS,
    LUX_INSURANCE_RISK_LABELS,
    LUX_INSURANCE_SEPARABLE_RISKS,
    LUX_INSURANCE_PAGE_SIZE,
    LUX_INSURANCE_PENDING_TIMEOUT_MS,
    LUX_INSURANCE_SECTION_HASH,
    LUX_INSURANCE_NOTICE_KEY,
    LUX_INSURANCE_FORM_SECTION_ID,
  }
}
